import gql from 'graphql-tag'
import { useSearchParams } from 'next/navigation'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

import { SIZES } from '~/common/globalStyles'
import {
  ResendInviteResendInvitationMutation,
  ResendInviteResendInvitationMutationVariables,
} from '~/common/types/graphql'
import LogoCard from '~/views/components/LogoCard'
import {
  UnauthedBody,
  UnauthedLayout,
} from '~/views/components/elements/Layout'
import Link from '~/views/components/routing/Link'
import { LoadingButton } from '~/views/components/ui/Button'
import Text from '~/views/components/ui/Text'
import TextField from '~/views/components/ui/inputs/TextField'
import useErrorHandlingMutation from '~/views/hooks/useErrorHandlingMutation'
import GlobalLayout from '~/views/layouts/GlobalLayout'

const FormLayout = styled.form`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 35px;
  grid-gap: ${SIZES.medium};
`
const FormOptions = styled.div`
  margin-top: ${SIZES.medium};
  text-align: right;
`

const RESEND_INVITE_MUTATION = gql`
  mutation ResendInvite_ResendInvitation($email: String!) {
    resendInviteToUser(input: { email: $email }) {
      success
    }
  }
`

const ResendInvite = () => {
  const searchParams = useSearchParams()
  const [loading, setLoading] = useState(false)
  const [email, setEmail] = useState('')
  const [emailSent, setEmailSent] = useState(false)
  const [resendInviteToUser, { data, loading: updating }] =
    useErrorHandlingMutation<
      ResendInviteResendInvitationMutation,
      ResendInviteResendInvitationMutationVariables
    >(RESEND_INVITE_MUTATION, {}, true)

  const handleResendInvite = () => {
    setLoading(true)
    resendInviteToUser({
      variables: { email },
    })
  }

  useEffect(() => {
    if (!updating && data) {
      setLoading(false)
    }
  }, [updating, data])

  const returnTo = searchParams?.get('returnTo') ?? '/auth/login'

  return (
    <GlobalLayout>
      <UnauthedLayout>
        <UnauthedBody>
          <LogoCard width={420}>
            {!emailSent && (
              <FormLayout
                onSubmit={(event) => {
                  event.preventDefault()
                  setEmailSent(true)
                  handleResendInvite()
                  setLoading(true)
                }}
              >
                <TextField
                  label="Email Address"
                  value={email}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setEmail(event.target.value)
                  }}
                  type="email"
                  required
                  fullWidth
                />
                <LoadingButton
                  color="newPrimary"
                  raised
                  large
                  type="submit"
                  loading={loading}
                  buttonText="Resend Invite"
                />
              </FormLayout>
            )}
            {emailSent && (
              <Text>
                If that email address is in our database, we will resend you an
                email with your invitation.
              </Text>
            )}
            <FormOptions>
              <Link href={returnTo} color="black">
                Back to Login
              </Link>
            </FormOptions>
          </LogoCard>
        </UnauthedBody>
      </UnauthedLayout>
    </GlobalLayout>
  )
}

export default ResendInvite
